let apidaePrestaFairGuest = {

    props: {
        prestaItem: Object,
        uri: String
    },
    computed: {
        calculateCircumference: function() {
            return Math.round(2 * Math.PI * this.radius)
        }
    },
    components: {},
    directives: {},
    data() {
        return {
            fairguestApiUrl: 'https://api.tourism-system.com',
            fairguestApiLitePrivate: '/widgets/public/fairguest/sheetslite',
            fairguestApiDetail: '/widgets/public/fairguest/sheets',
            fairguestApiUsername: '',
            fairguestApiPassword: '',
            fairguestApiGroup: '596',
            fairguestApiPrefixeFicheSource: 'sitra2i-CRTPACA-',
            fairguestItem: {},
            percentageRating1: 0,
            percentageRating2: 0,
            percentageRating3: 0,
            percentageRating4: 0,
            percentageRating5: 0,
            chart: 'bar', //circle, bar
            radius: 55,
            coordonnee: 77,
            strokeWidth: 6,
            wordsMost: [],
            words: [['romance', 19], ['horror', 3],  ['fantasy', 7], ['adventure', 3]]
        }
    },
    methods: {
        calculateStrokeLength: function(percentage) {
            return Math.round((this.calculateCircumference / 100) * percentage)
        },
        arrayNgramsMost: function(ngrams) {
            return ngrams.map(ngram => [ngram.expression, ngram.count])
        }
    },
    mounted: function() {
        query = `?fairguest_group=${this.fairguestApiGroup}&idFicheSource=${this.fairguestApiPrefixeFicheSource}${this.prestaItem.prestaVO.idPrestation}`
        let headers = new Headers()
        headers.set("Content-Type", "application/json")
        headers.set('Authorization', 'Basic ' + btoa(this.fairguestApiUsername + ":" + this.fairguestApiPassword))
        headers.set('Access-Control-Allow-Origin', '*')
        fetch(this.fairguestApiUrl + this.fairguestApiDetail + query, {
                method: 'GET',
                headers: headers
            })
            .then(stream => stream.json())
            .then(data => {
                this.fairguestItem = data
                this.percentageRating1 = Math.round((data.fairguest_counts.count_rating_1 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating2 = Math.round((data.fairguest_counts.count_rating_2 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating3 = Math.round((data.fairguest_counts.count_rating_3 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating4 = Math.round((data.fairguest_counts.count_rating_4 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
                this.percentageRating5 = Math.round((data.fairguest_counts.count_rating_5 / data.fairguest_counts.rated_count_not_older_than_one_year) * 100)
    
                // this.wordsMost = this.arrayNgramsMost(data.ngrams.most)
            })
            .catch(error => console.error(error))
    
    
    },
    template: `
    <div id="FairGuest" class="prestaFairguest" v-if="fairguestItem.fairguest_counts">
        <header class="fg-header">
            <div class="fg-header__title">
                <div class="fa-3x">
                    <span class="fa-layers fa-fw" style="background:transparent">
                        <i class="fas fa-star"></i>
                        <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11 down-1" style="font-weight:900">{{ fairguestItem.fairguest_counts.weighted_rating|round(1) }}</span>
                    </span>
                </div>
            </div>
            <div class="fg-header__subline">
                {{ fairguestItem.fairguest_counts.rated_count_not_older_than_one_year }} avis client
            </div>
        </header>
        <section class="fg-counts">
            <ul class="fg-circle-chart no-bullet" v-if="chart == 'circle'">
                <li>
                    <svg class="circle-chart" viewbox="0 0 154 154" width="154" height="154" xmlns="http://www.w3.org/2000/svg">
                        <circle class="circle-chart__background" stroke="#efefef" :stroke-width="strokeWidth" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <circle class="circle-chart__circle" stroke="#3D8600" :stroke-width="strokeWidth" :stroke-dasharray="calculateStrokeLength(percentageRating5) + ',' + calculateCircumference" stroke-dashoffset="100" stroke-linecap="round" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <g class="circle-chart__info">
                            <text class="circle-chart__percent" :x="coordonnee" :y="coordonnee" alignment-baseline="central" text-anchor="middle" font-size="24">{{ percentageRating5 }}%</text>
                        </g>
                    </svg>
                    <span class="circle-chart__label" style="color: #3D8600">Excellent</span>
                </li>
                <li>
                    <svg class="circle-chart" viewbox="0 0 154 154" width="154" height="154" xmlns="http://www.w3.org/2000/svg">
                        <circle class="circle-chart__background" stroke="#efefef" :stroke-width="strokeWidth" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <circle class="circle-chart__circle" stroke="#71a63e" :stroke-width="strokeWidth" :stroke-dasharray="calculateStrokeLength(percentageRating4) + ',' + calculateCircumference" stroke-linecap="round" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <g class="circle-chart__info">
                            <text class="circle-chart__percent" :x="coordonnee" :y="coordonnee" alignment-baseline="central" text-anchor="middle" font-size="24">{{ percentageRating4 }}%</text>
                        </g>
                    </svg>
                    <span class="circle-chart__label" style="color: #71a63e">Très bon</span>
                </li>
                <li>
                    <svg class="circle-chart" viewbox="0 0 154 154" width="154" height="154" xmlns="http://www.w3.org/2000/svg">
                        <circle class="circle-chart__background" stroke="#efefef" :stroke-width="strokeWidth" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <circle class="circle-chart__circle" stroke="#9fbf04" :stroke-width="strokeWidth" :stroke-dasharray="calculateStrokeLength(percentageRating3) + ',' + calculateCircumference" stroke-linecap="round" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <g class="circle-chart__info">
                            <text class="circle-chart__percent" :x="coordonnee" :y="coordonnee" alignment-baseline="central" text-anchor="middle" font-size="24">{{ percentageRating3 }}%</text>
                        </g>
                    </svg>
                    <span class="circle-chart__label" style="color: #9fbf04">Bon</span>
                </li>
                <li>
                    <svg class="circle-chart" viewbox="0 0 154 154" width="154" height="154" xmlns="http://www.w3.org/2000/svg">
                        <circle class="circle-chart__background" stroke="#efefef" :stroke-width="strokeWidth" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <circle class="circle-chart__circle" stroke="#F8A025" :stroke-width="strokeWidth" :stroke-dasharray="calculateStrokeLength(percentageRating2) + ',' + calculateCircumference" stroke-linecap="round" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <g class="circle-chart__info">
                            <text class="circle-chart__percent" :x="coordonnee" :y="coordonnee" alignment-baseline="central" text-anchor="middle" font-size="24">{{ percentageRating2 }}%</text>
                        </g>
                    </svg>
                    <span class="circle-chart__label" style="color: #F8A025">Moyen</span>
                </li>
                <li>
                    <svg class="circle-chart" viewbox="0 0 154 154" width="154" height="154" xmlns="http://www.w3.org/2000/svg">
                        <circle class="circle-chart__background" stroke="#efefef" :stroke-width="strokeWidth" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <circle class="circle-chart__circle" stroke="#E03313" :stroke-width="strokeWidth" :stroke-dasharray="calculateStrokeLength(percentageRating1) + ',' + calculateCircumference" stroke-linecap="round" fill="none" :cx="coordonnee" :cy="coordonnee" :r="radius" />
                        <g class="circle-chart__info">
                            <text class="circle-chart__percent" :x="coordonnee" :y="coordonnee" alignment-baseline="central" text-anchor="middle" font-size="24">{{ percentageRating1 }}%</text>
                        </g>
                    </svg>
                    <span class="circle-chart__label" style="color: #E03313">Médiocre</span>
                </li>
            </ul>
            <ul class="fg-bar-chart no-bullet" v-if="chart == 'bar'">
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating5 + '%'" style="background-color: #3D8600"></span>
                    <span class="bar-chart__label">Excellent {{ percentageRating5 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating4 + '%'" style="background-color: #71a63e"></span>
                    <span class="bar-chart__label">Très bon {{ percentageRating4 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating3 + '%'" style="background-color: #9fbf04"></span>
                    <span class="bar-chart__label">Bon {{ percentageRating3 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating2 + '%'" style="background-color: #F8A025"></span>
                    <span class="bar-chart__label">Moyen {{ percentageRating2 }}%</span>
                </li>
                <li class="bar-chart">
                    <span class="bar-chart__bar"></span>
                    <span class="bar-chart__percent" :style="'width: ' + percentageRating1 + '%'" style="background-color: #E03313"></span>
                    <span class="bar-chart__label">Médiocre {{ percentageRating1 }}%</span>
                </li>
            </ul>
            
        </section>
        <section class="fg-tags" v-if="fairguestItem.ngrams.most.length > 0">
            <p><strong>Expressions des vacanciers les plus souvent utilisées pour cet établissement :</strong></p>
            <ul class="no-bullet">
                <li class="button hollow" v-for="(word, index) in fairguestItem.ngrams.most" style="margin-right: 8px" :style="'opacity: ' + (100 - index*2)/100">{{ word.expression }} ({{ word.count }})</li>
            </ul>
        </section>
        <section class="fg-providers">
            <p><strong>Note et nombres d'avis par services :</strong></p>
            <ul class="flex no-bullet">
                <li class="fg-provider" v-for="(provider, index) in fairguestItem.fairguest_counts.providers" style="margin-right: 8px"><img :src="base_url + '/' + theme_url + '/img/fairguest/' + provider.type + '.png'" /><strong>{{ provider.weighted_rating|round(1) }} </strong><span>{{ provider.rated_count }}</span></li>
            </ul>
        </section>
        <footer class="fg-footer">
            <div class="fg-footer__subline">
                Données calculées sur {{ fairguestItem.fairguest_counts.rated_count_not_older_than_one_year }} avis collectés sur les 3 dernières années. Ces données sont fournies par la solution www.fairguest.com et n'engagent pas l'Office de Tourisme.
            </div>
        </footer>
    </div>
    `
    };